module.exports = __webpack_public_path__ + "img/2022_09_dandelion_oldmitsuifamily_fin_web.17439c28.png";